/* global Blockly */
import React from 'react';
import { userIcon } from './index';
import { markBlockAsDeprecated } from '../../../helpers';

function defineBlock(context) {
    return {
        init: function () {
            markBlockAsDeprecated(this, 'This block was deprecated, please use the "Get user field" block instead.');

            this.appendDummyInput('WIDGET')
                .appendField('get')
                .appendField(new Blockly.FieldImage(userIcon, 30, 30, "user icon", null), 'userIcon')
                .appendField(new Blockly.FieldVariable(),'VARIABLE')
                .appendField('id')
                .setOnNewRow(true);

            this.appendStatementInput('CALLBACK');

            this.setPreviousStatement(true, null);
            this.setNextStatement(true, null);
            this.setColour(Blockly.Msg.WIDGET_VALUES_HUE);
            this.setTooltip('Get the id of a logged in user.');
            this.setHelpUrl(Blockly.BASE_HELP_URL + "#user");
        }
    }
}

function defineGenerators() {
    return {
        'JavaScript': function (block) {
            let variableName = Blockly.JavaScript.variableDB_.getName(block.getField('VARIABLE').getText(), Blockly.Variables.NAME_TYPE);
            let callback = Blockly.JavaScript.statementToCode(block, 'CALLBACK');
            return 'Snap.user.getUserId(function(' + variableName + ') {' + callback + '});\n';
        }
    }
}

const GetUserId = function (props) {
    const name = 'snap_user_get_id';
    GetUserId.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);
    let generators = defineGenerators();
    for (let i in generators) {
        Blockly[i][name] = generators[i];
    }

    return <block type={name}></block>;
}

export default GetUserId;
